// extracted by mini-css-extract-plugin
export var textInput = "_jc-0";